module.exports = __webpack_public_path__ + "img/safe2.04136250.svg";